import { render, staticRenderFns } from "./thing_index.vue?vue&type=template&id=56674e96&"
import script from "./thing_index.vue?vue&type=script&lang=js&"
export * from "./thing_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports